<template>
  <div class="page">
    <div>
      <div class="talet-tabs">
        <div class="talet-tabs-left">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="name1" name="first">
              <el-table

                :data="tableData"
                style="width: 100%"
                :default-sort="{ prop: 'date', order: 'descending' }"
              >
                <el-table-column
                  prop="platform"
                  label="平台"
                  align="center"
                  width="80"
                >
                  <template slot-scope="scope">
                    <div class="nickname2">
                      <img src="../../assets/images/douyin.png" srcset="" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="nickname" label="达人" align="center">
                  <template slot-scope="scope">
                    <div class="nickname">
                      <img :src="scope.row.avatar" srcset="" />
                      {{ scope.row.nickname }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="shop_sales"
                  label="橱窗销量"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="post_name" label="收货人" align="center">
                </el-table-column>
                <el-table-column
                  prop="post_telephone"
                  label="收货电话"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="post_address"
                  label="收货信息"
                  align="center"
                >
                  <template slot-scope="scope">
                    <span
                      style="
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                      "
                    >
                      {{ scope.row.post_address }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="address"
                  label="操作"
                  width="300"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          ><el-button
                            style="background-color: #229fa0; color: #f6f7fb"
                            size="small"
                            @click="openupadtebox(scope.row)"
                            >修改</el-button
                          ></el-dropdown-item
                        >
                        <el-dropdown-item>
                          <el-button
                            type="danger"
                            size="small"
                            @click="del(scope.row.id)"
                            >删除</el-button
                          ></el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                    <el-button
                      size="small"
                      @click="particulars(scope.row)"
                      style="background-color: #229fa0; color: #f6f7fb"
                      >详情</el-button
                    >
                    <el-button
                      style="background-color: #229fa0; color: #f6f7fb"
                      size="small"
                      @click="open_url(scope.row.home_url)"
                      >主页链接</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="name2" name="second"> </el-tab-pane>
            <el-tab-pane :label="name3" name="third"> </el-tab-pane>
          </el-tabs>
        </div>
        <div class="right-box">
          <div>
            <el-select
              v-model="selcet"
              style="width: 60%"
              @change="selectChanged"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
          <div>
            <el-input
              placeholder="请输入内容"
              v-model="query.keyword"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="inputserch"
              ></el-button>
            </el-input>
          </div>
          <div>
            <el-button
              style="background-color: #229fa0; color: #f6f7fb"
              @click="openbox"
              >新增达人</el-button
            >
          </div>
          <add-box ref="chird"></add-box>
          <upadate-box ref="chird2" v-bind:listtable="listtable"></upadate-box>
        </div>
      </div>
    </div>

    <div class="block">
      <el-pagination
        background
        layout="total,sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :total="total"
        @size-change="sizeChangeHandle"
        :page-sizes="[10, 20, 50, 100, 200]"
      ></el-pagination>
    </div>

    <el-dialog
      title="达人详情"
      :visible.sync="dialogVisible2"
      width="30%"
      :close-on-click-modal="false"
    >
      <div class="xiangqing">
        <el-avatar :size="80" :src="add.avatar"></el-avatar>
        <div>{{ add.nickname }}</div>
        <div>{{ add.unique_id }}</div>
      </div>
      <div class="xiangqing-buttom">
        <el-row>
          <el-col :span="6">
            <span>微信号</span>
          </el-col>
          <el-col :span="16">{{ add.weixinid }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>总销量</span>
          </el-col>
          <el-col :span="16">{{ add.shop_sales }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>备注</span>
          </el-col>
          <el-col :span="16">{{ add.remark }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>收货人</span>
          </el-col>
          <el-col :span="16">{{ add.post_name }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>收货电话</span>
          </el-col>
          <el-col :span="16">{{ add.post_telephone }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <span>收货地址</span>
          </el-col>
          <el-col :span="16">{{ add.post_address }}</el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import AddBox from './AddBox.vue'
import UpadateBox from './UpadateBox.vue'

import { ExpertsAll, DelExperts } from '../../api/api2'
export default {
  components: {
    AddBox,
    UpadateBox,
  },
  created() {
    this.getAll()
  },
  methods: {
    //每页条数
    sizeChangeHandle(val) {
      this.query.list_rows = val
      this.getAll()
    },
    handleCurrentChange(e) {
      this.query.pageSize = e
      this.getAll()
    },
    open_url(id) {
      window.open(id, '_blank')
    },
    del(id) {
      let params = new URLSearchParams()
      params.append('id', id)
      // params.append("url", this.add.home_url);
      DelExperts(params)
        .then((res) => {
          this.$message.success('删除达人成功')
          this.getAll()
        })
        .catch((error) => {
          if (error.response.status == '422') {
            // this.$message.error("删除达人失败");
            this.$message.error(error.response.data.message)
          } else {
            this.$message.error('删除达人失败')
          }
        })
    },
    particulars(list) {
      this.dialogVisible2 = true
      this.add.unique_id = list.unique_id
      this.add.nickname = list.nickname
      this.add.home_url = list.home_url
      this.add.avatar = list.avatar
      this.add.platform = list.platform
      this.add.remark = list.remark
      this.add.weixinid = list.weixinid
      this.add.post_name = list.post_name
      this.add.post_telephone = list.post_telephone
      this.add.post_address = list.post_address
      this.add.shop_sales = list.shop_sales
      this.avatar = list.avatar
      console.log("_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+_+",this.avatar);
      this.add.nickname = list.nickname
    },
    getAll() {
      let params = new URLSearchParams()
      params.append('model', this.query.model)
      params.append('list_rows', this.query.list_rows)
      params.append('page', this.query.pageSize)
      params.append('status', this.query.status)
      params.append('platform', this.query.platform)
      params.append('keyword', this.query.keyword)
      ExpertsAll(params)
        .then((res) => {
          this.tableData = res.data.data
          this.total = res.data.total
        })
        .catch((error) => {
          if (error.response.status == '422') {
            this.$message.error('获取失败')
          }
        })
    },
    opeUrl(id) {
      window.location = id
    },
    selectChanged(value) {
      if (value == '') {
        this.getAll()
      } else if (value == 'douyin') {
        this.query.platform = 'douyin'
        this.getAll()
      } else {
        this.query.platform = 'kuaishou'
        this.getAll()
      }
      {
      }
    },
    inputserch() {
      this.getAll()
    },
    openbox() {
      this.$refs.chird.openbox()
    },
    //修改达人的按钮触发
    openupadtebox(row) {
      this.listtable = row
    // console.log('balance',this.listtable);
      this.$refs.chird2.openbox()
    },
    formatter(row, column) {
      return row.address
    },
    handleClick(tab) {
      if (tab.name == 'first') {
        this.query.status = 0
        this.getAll()
      } else if (tab.name == 'second') {
        this.query.status = 1
        this.getAll()
      } else if (tab.name == 'third') {
        this.query.status = 2
        this.getAll()
      }
    },
  },

  data() {
    return {
      dialogVisible2: false,
      add: {
        nickname: '',
        avatar: '',
        platform: '抖音',
        home_url: '',
        unique_id: '',
        shop_sales: '',
        remark: '',
        weixinid: '',
        post_name: '',
        post_telephone: '',
        post_address: '',
      },
      listtable: [],
      name1: '已通过 (0)',
      name2: '审核中 (0)',
      name3: '未通过 (0)',
      options: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 'douyin',
          label: '抖音',
        },
        {
          value: 'kuaishou',
          label: '快手',
        },
      ],
      selcet: '',
      name: '',
      total: 0,
      activeName: 'first',
      tableData: [],
      query: {
        keyword: '',
        status: '',
        list_rows: 10,
        model: '',
        pageSize: 1,
        platform: '',
      },
    }
  },
}
</script>
<style lang="less" scoped>
.page {
  padding: 20px 10px;
  background-color: #ffff;
  .block {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
  .xiangqing-buttom {
    padding: 10px;
    // display: flex;

    .el-row {
      //  text-align: center;
      margin: 20px 90px;
      .el-col {
        span {
          font-weight: bold;
        }
      }
    }
  }
  .xiangqing {
    text-align: center;

    div {
      padding: 5px 0;
    }
  }
  .nickname2 {
    text-align: center;
    // display: flex;
    // justify-content: center;
    // align-content: center;
    // align-items: center;
    img {
      margin-right: 10px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
    }
  }
  .nickname {
    display: flex;
    // justify-content: center;
    margin-left: 10px;
    align-content: center;
    align-items: center;
    img {
      margin-right: 10px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
  .talet-tabs {
    position: relative;
    .talet-tabs-left {
    }
    .right-box {
      position: absolute;
      right: 0;
      top: -10px;
      display: flex;
      align-items: center;
      div {
        margin: 0 20px;
        .el-select {
          position: relative;
          right: -120px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/balance/balance.vue